import { ConfirmationService, MenuItem, Message } from 'primeng/api';
import { LoginCredentials } from 'src/app/models/LoginCredentials';
import { BrowserDetectorService, BrowserInfo } from 'src/app/services/browser-detector/browser-detector.service';
import { TrustBuilderErrorModel } from 'src/app/models/TrustBuilderErrorModel';
import { EventEmitter, Injectable, inject } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { TranslateService } from '@ngx-translate/core';
import { AuthentificationService } from '../services/auth/authentification.service';
import { ToastService } from '../services/toast.service';
import {TrustbuilderUtils} from "../utils/trustbuilder-utils";
declare var Neon;

@Injectable()
export class TrustbuilderDispatcher {

  private confirmationService = inject(ConfirmationService);
  private browserDetector = inject(BrowserDetectorService);
  private toastService = inject(ToastService);
  private trustbuilderUtils = inject(TrustbuilderUtils);
  public translate;

  credentials = new LoginCredentials();
  trustBuilderAuthEvent = new EventEmitter<any>();
  clearLoginError = new EventEmitter<any>();

  neon: any;
  mfaLoginAsk: boolean = false;
  mfaDeviceLoginAsk: boolean = false;
  mfaRegisterAsk: boolean = false;
  mfaUserBlockedAsk: boolean = false;
  mfaResetPinAsk: boolean = false;
  mfaNewUserAsk: boolean = false;
  mfaResetPinAskActiveIndex: number = 0;
  activationCode: string;
  deviceName: string;
  deviceNameDefault: string;
  pinContainerShow = false;
  pin: string = "";
  pinConf: string = "";
  pinErrorRequired = false;
  pinErrorWrong = false;
  pinConfErrorRequired = false;
  pinConfErrorWrong = false;
  activationCodeErrorRequired = false;
  activationCodeErrorWrong = false;
  deviceNameErrorRequired = false;
  mfaSpinner = false;
  mfaGlobalSpinner = true;
  mfaLoginList = [];
  pinInputList;
  pinInputTypePassword = true;
  resetCode;
  resetCodeErrorRequired;
  resetCodeErrorWrong;
  passwordErrorRequired;
  resetPin;
  confResetPin;
  resetPinErrorRequired;
  resetPinErrorWrong;
  confResetPinErrorRequired;
  confResetPinErrorWrong;
  newUsername;
  routeItems: MenuItem[] = [];
  accountSyncWarnAsk : boolean = false;

  constructor(translateService : TranslateService, authentication: AuthentificationService) {
    this.translate = translateService;
    authentication.getMfaAlias().subscribe(alias => {
      if (alias) {
        this.initMfa(alias);
      } else {
        this.mfaGlobalSpinner = false;
      }
    }, () => this.mfaGlobalSpinner = false);
  }


  initMfa(alias : string) {
    this.routeItems = [{ label: this.translate.instant("login.mfa.reset-pin-step-1")}, { label: this.translate.instant("login.mfa.reset-pin-step-2") }, { label: this.translate.instant("login.mfa.reset-pin-step-3") }];
    this.setPinInputList();
    this.setDefaultDeviceName();
    this.neon = new Neon.Neon({
      alias: alias,
      useIframe: true
    });

    this.neon.initOnline().then(logins => {
      this.mfaGlobalSpinner = false;
      if (logins.length > 0) {
        this.mfaLoginAsk = true;
        this.mfaLoginList = logins.map(login => this.trustbuilderUtils.usernameOf(login));
      }
    }).catch(e => {
      this.mfaGlobalSpinner = false;
    });
  }

  setPinInputList() {
    this.pinInputList = Array.from(Array(10).keys()).map(value => ({ value, sort: Math.random() }))
      .sort((left, right) => left.sort - right.sort)
      .map(({ value }) => value);
  }

  setDefaultDeviceName() {
    const browserInfo: BrowserInfo = this.browserDetector.getBrowserAndVersion();
    let browserInfoArray = [];
    if (browserInfo.name !== undefined) {
      browserInfoArray.push(browserInfo.name);
    }
    if (browserInfo.fullVersion !== undefined) {
      browserInfoArray.push(browserInfo.fullVersion);
    }
    if (browserInfo.platform !== undefined) {
      browserInfoArray.push(browserInfo.platform);
    }
    this.deviceNameDefault = browserInfoArray.join(' ');
    this.resetDeviceName();
  }

  resetDeviceName() {
    this.clearDeviceNameErrors();
    this.deviceName = JSON.parse(JSON.stringify(this.deviceNameDefault));
  }

  processMfaValidation(data) {
    let username = this.credentials.username;
    this.credentials = new LoginCredentials();
    this.credentials.username = username;
    if (data.validation == 1) {
      this.mfaRegisterAsk = true;
    } else if (data.validation == 2) {
      this.mfaDeviceLoginAsk = true;
    } else if (data.validation == 3) {
      this.mfaResetPinAskActiveIndex++;
    } else if (data.validation == 4) {
      this.mfaUserBlockedAsk = true;
    }
  }

  clearState() {
    this.clearLoginError.emit(true);
    this.mfaSpinner = false;
    this.activationCode = "";
    this.pin = "";
    this.pinConf = "";
    this.mfaResetPinAskActiveIndex = 0;
    this.resetPin = "";
    this.confResetPin = "";
    this.resetCode = "";
    this.resetDeviceName();
    this.pinContainerClear();
    this.clearActivationCodeErrors();
    this.clearDeviceNameErrors();
    this.clearPinConfErrors();
    this.clearResetCodeErrors();
    this.clearPasswordErrors();
    this.clearResetPinErrors();
    this.clearConfResetPinErrors();
  }

  pinContainerHideFromDeviceLogin() {
    if (this.mfaDeviceLoginAsk) {
      this.pinContainerHide();
    }
  }

  pinContainerHideFromLogin() {
    if (this.mfaLoginAsk) {
      this.pinContainerHide();
    }
  }

  pinContainerHide() {
    this.pinContainerShow = false;
    this.pinInputTypePassword = true;
  }

  pinContainerClear() {
    this.pin = "";
    this.clearPinErrors();
  }

  pinInputHideClick() {
    this.pinInputTypePassword = !this.pinInputTypePassword;
  }

  pinContainerClick() {
    if (!this.pinContainerShow) {
      this.setPinInputList();
      this.pinContainerShow = true;
    }
  }

  resetPinShow() {
    this.clearState();
    this.mfaResetPinAsk = true;
  }

  resetPinHide() {
    this.mfaSpinner = false;
    this.mfaResetPinAsk = false;
  }

  clearPinErrors() {
    this.pinErrorRequired = false;
    this.pinErrorWrong = false;
  }

  clearPinConfErrors() {
    this.pinConfErrorRequired = false;
    this.pinConfErrorWrong = false;
  }

  clearActivationCodeErrors() {
    this.activationCodeErrorRequired = false;
    this.activationCodeErrorWrong = false;
  }

  clearResetCodeErrors() {
    this.resetCodeErrorRequired = false;
    this.resetCodeErrorWrong = false;
  }

  clearResetPinErrors() {
    this.resetPinErrorRequired = false;
    this.resetPinErrorWrong = false;
  }

  clearConfResetPinErrors() {
    this.confResetPinErrorRequired = false;
    this.confResetPinErrorWrong = false;
  }

  clearDeviceNameErrors() {
    this.deviceNameErrorRequired = false;
  }

  clearPasswordErrors() {
    this.passwordErrorRequired = false;
  }

  isDeviceLoginValid(save: boolean) {
    if (!this.pin || this.pin.length == 0) {
      this.pinErrorRequired = true;
    }
    if (!this.activationCode || this.activationCode.length == 0) {
      this.activationCodeErrorRequired = true;
    }
    if (save && (!this.deviceName || this.deviceName.length == 0)) {
      this.deviceNameErrorRequired = true;
    }
    if (!save) {
      this.clearDeviceNameErrors();
    }
    return !this.pinErrorRequired && !this.activationCodeErrorRequired && !this.deviceNameErrorRequired;
  }

  isRegisterValid(save: boolean) {
    if (!this.pinConf || this.pinConf.length == 0) {
      this.pinConfErrorRequired = true;
    } else if (this.pin != this.pinConf) {
      this.pinConfErrorWrong = true;
    }

    return this.isDeviceLoginValid(save) && !this.pinConfErrorRequired && !this.pinConfErrorWrong;
  }

  isValidatePwdValid() {
    if (!this.credentials.password || this.credentials.password.length == 0) {
      this.passwordErrorRequired = true;
    }
    return !this.passwordErrorRequired;
  }

  isResetPinValid() {
    if (!this.resetCode || this.resetCode.length == 0) {
      this.resetCodeErrorRequired = true;
    }
    if (!this.resetPin || this.resetPin.length == 0) {
      this.resetPinErrorRequired = true;
    }
    if (!this.confResetPin || this.confResetPin.length == 0) {
      this.confResetPinErrorRequired = true;
    }
    if (this.resetPin != this.confResetPin) {
      this.confResetPinErrorWrong = true;
    }
    return !this.resetCodeErrorRequired && !this.resetPinErrorRequired
      && !this.confResetPinErrorRequired && !this.confResetPinErrorWrong;
  }

  deviceLoginAndSaveSubmit() {
    if (this.isDeviceLoginValid(true)) {
      this.mfaSpinner = true;
      this.credentials.saveDevice = true;
      this.mfaDeviceLogin();
    }
  }

  deviceLoginSubmit() {
    if (this.isDeviceLoginValid(false)) {
      this.mfaSpinner = true;
      this.credentials.saveDevice = false;
      this.mfaDeviceLogin();
    }
  }

  registerAndSaveSubmit() {
    if (this.isRegisterValid(true)) {
      this.mfaSpinner = true;
      this.credentials.saveDevice = true;
      this.mfaRegister();
    }
  }

  registerSubmit() {
    if (this.isRegisterValid(false)) {
      this.mfaSpinner = true;
      this.credentials.saveDevice = false;
      this.mfaRegister();
    }
  }

  validatePasswordSubmit() {
    if (this.isValidatePwdValid()) {
      this.mfaSpinner = true
      this.credentials.resetPin = true;
      this.trustBuilderAuthEvent.emit();
      this.credentials.resetPin = false;
    }
  }

  resetPinSubmit() {
    this.clearResetCodeErrors();
    this.clearResetPinErrors();
    this.clearConfResetPinErrors();
    if (this.isResetPinValid()) {
      this.mfaResetPin();
    }
  }

  mfaDeviceLogin() {
    this.mfaActivate();
  }

  mfaLogin() {
    this.credentials.saveDevice = true;
    this.mfaOtp(this.credentials.username);
  }

  mfaRegister() {
    this.mfaActivate();
  }

  mfaActivate() {
    this.activate(this.activationCode, this.deviceName);
  }

  activate(activationCode, deviceName) {
    this.neon.activate(activationCode, deviceName, this.activateDisplayAskForPin.bind(this.pin), this.activateDisplayDefinePin.bind(this.pin))
      .then(login => this.displayActivate(this.trustbuilderUtils.usernameOf(login)))
      .catch(e => this.displayActivateError(e));
  }

  activateDisplayAskForPin() {
    return new Promise((resolve) => {
      resolve(this);
    });
  }

  activateDisplayDefinePin() {
    return new Promise((resolve) => {
      resolve(this);
    })
  }

  mfaOtp(login) {
    this.neon.getOnlineOtp(this.trustbuilderUtils.aliasOf(login), this.getOnlineOtpDisplayAskForPin.bind(this.pin))
      .then(otp => this.extractOnlineOtp(otp))
      .catch(e => this.extractOnlineError(e));
  }

  displayActivate(login) {
    this.mfaOtp(login);
  }

  displayActivateError(error) {
    this.mfaHandleError(error);
  }

  mfaResetPin() {
    this.neon.resetPin(this.trustbuilderUtils.aliasOf(this.credentials.username), this.resetCode, this.resetPin).then(() => this.resetPinSuccess()).catch(e => this.displayResetPinError(e));
  }

  resetPinSuccess() {
    this.mfaResetPinAskActiveIndex++;
  }

  displayResetPinError(error) {
    this.mfaHandleError(error);
  }

  mfaHandleError(error: TrustBuilderErrorModel) {
    this.mfaSpinner = false;
    if (error.errCode == 'USER_IS_BLOCKED') {
      this.mfaDeviceLoginAsk = false;
      this.mfaRegisterAsk = false;
      //this.mfaResetPinAsk = true;
      this.mfaUserBlockedAsk = true;
    }
    if (error.errCode == 'PASSWORD_IS_WRONG') {
      this.pinErrorWrong = true;
    }
    if (error.errCode == 'CODE_ENTRY_DOES_NOT_EXIST' || error.errCode == 'INVALID_JSON') {
      if (this.mfaDeviceLoginAsk || this.mfaRegisterAsk) {
        this.activationCodeErrorWrong = true;
      }
      if (this.mfaResetPinAsk) {
        this.resetCodeErrorWrong = true;
      }
    }
    if (error.errCode == 'PIN_REFUSED') {
      if (this.mfaResetPinAsk) {
        this.resetPinErrorWrong = true;
      } else {
        this.pinErrorWrong = true;
      }
    }
    if ((error.errCode == 'ACCOUNT_NOT_FOUND' || error.errCode == 'MA_ENTRY_DOES_NOT_EXIST') && this.mfaLoginAsk) {
        this.accountSyncWarnAsk = true;
    }
  }

  getOnlineOtpDisplayAskForPin(biokeyAllowed) {
    return new Promise((resolve) => {
      resolve({
        value: this,
        wikType: "PASSWORD"
      });
    });
  }

  extractOnlineOtp(otp) {
    this.credentials.otp = JSON.parse(JSON.stringify(otp));
    this.mfaSpinner = true
    this.credentials.resetPin = false;
    this.trustBuilderAuthEvent.emit();
    this.showDeviceSaveManagementToast();
  }

  showDeviceSaveToast() {
    this.toastService.add({
      key: 'global',
      severity: 'success',
      summary: this.translate.instant("login.mfa.save-device-success-title"),
      detail: this.deviceName + this.translate.instant("login.mfa.save-device-success-body")});
  }

  showDeviceNoSaveToast() {
    this.toastService.add({
      key: 'global',
      severity: 'info',
      summary: this.translate.instant("login.mfa.no-save-device-success-title"),
      detail: this.translate.instant("login.mfa.no-save-device-success-body")});
  }

  showDeviceSaveManagementToast() {
    if (this.mfaDeviceLoginAsk || this.mfaRegisterAsk) {
      setTimeout(() => {
        if (this.credentials.saveDevice) {
          this.showDeviceSaveToast();
        } else {
          this.showDeviceNoSaveToast();
        }
      }, 2000)
    }
  }

  extractOnlineError(error) {
    this.mfaHandleError(error);
  }

  pinInputClick(pinInput) {
    this.clearPinErrors();
    this.pin = this.pin + pinInput;
  }

  infoDeviceName(event: Event) {
    this.confirmationService.confirm({
      key: 'infoDeviceName',
      target: event.target || new EventTarget,
      message: this.translate.instant("login.mfa.info-device-name"),
      acceptVisible: true,
      rejectVisible: false,
      acceptLabel: this.translate.instant("login.mfa.close")
    });
  }

  infoActivationCode(event: Event) {
    this.confirmationService.confirm({
      key: 'infoActivationCode',
      target: event.target || new EventTarget,
      message: this.translate.instant("login.mfa.info-activation-code"),
      acceptVisible: true,
      rejectVisible: false,
      acceptLabel: this.translate.instant("login.mfa.close")
    });
  }

  infoResetCode(event: Event) {
    this.confirmationService.confirm({
      key: 'infoResetCode',
      target: event.target || new EventTarget,
      message: this.translate.instant("login.mfa.info-init-code"),
      acceptVisible: true,
      rejectVisible: false,
      acceptLabel: this.translate.instant("login.mfa.close")
    });
  }

  addNewUserShow(event) {
    this.preventEvent(event);
    this.newUsername = null;
    this.mfaNewUserAsk = true;
  }

  addNewUserHide() {
    this.mfaNewUserAsk = false;
  }

  addNewUser(event, usernameDropdown : Dropdown) {
    this.preventEvent(event);
    this.addNewUserHide();
    usernameDropdown.hide();
    this.trackUsernameInput(this.newUsername);
    this.credentials.username = this.newUsername;
  }

  trackUsernameInput(username) {
    console.log("ssss")
    if (this.mfaLoginList.includes(username)) {
      this.mfaLoginAsk = true;
    } else {
      this.mfaLoginAsk = false;
    }
  }

  preventEvent(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  numbersOnly(event) {
    return !isNaN(event.key) || event.key == "Backspace";
  }

  isEmpty(value : string) : boolean{
    return value == null || value == undefined || value.length == 0;
  }

  reload() {
    location.reload();
  }

  resetPopUpPinShow(event: Event) {
    this.confirmationService.confirm({
      key: 'confirmForgotPin',
      target: event.target || new EventTarget,
      header: this.translate.instant("login.mfa.title-popup-forgot-pin"),
      message: this.translate.instant("login.mfa.description-popup-forgot-pin"),
      acceptVisible: true,
      rejectVisible: false,
      acceptLabel: this.translate.instant("login.mfa.close"),
      acceptIcon : 'pi pi-times'
    });
  }
}
